import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Stack } from '@mui/material';
// components
import Logo from '../components/Logo';
import Image from '../components/Image';
import useAuth from '../hooks/useAuth';
import { APP_NAME } from '../config';
// assets
// unused import removed

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
    },
}));

const SectionStyle = styled('div')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        position: 'relative',
        maxWidth: '50%', // Split screen 50/50
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
    },
}));

const ContentStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('md')]: {
        maxWidth: '50%',
        padding: theme.spacing(8),
    },
}));

const BackgroundImageStyle = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
});

const LogoStyle = styled(Box)(({ theme }) => ({
    top: theme.spacing(5),
    left: theme.spacing(5),
    zIndex: 9,
    [theme.breakpoints.up('md')]: {
        position: 'absolute',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: theme.spacing(3, 3, 0, 3), // Top, Right, Bottom(0), Left
        marginBottom: theme.spacing(3),
    },
}));

// ----------------------------------------------------------------------

AuthLayout.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    illustration: PropTypes.string,
};

export default function AuthLayout({ children, title, illustration }) {
    const { setting } = useAuth();
    const appName = setting?.general?.app_name || APP_NAME;

    return (
        <RootStyle>
            <LogoStyle>
                <Logo />
            </LogoStyle>

            <SectionStyle>
                {/* Clean White Background - No Image */}
                <Stack
                    sx={{
                        zIndex: 9,
                        position: 'relative',
                        textAlign: 'center',
                        color: 'text.primary',
                        px: 5
                    }}
                >
                    <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Welcome to <br /> {appName}
                    </Typography>
                    <Typography variant="body1" sx={{ maxWidth: 480, opacity: 0.8, mx: 'auto', color: 'text.secondary' }}>
                        Your trusted platform for digital services. Buy data, airtime, pay bills, and more.
                    </Typography>
                </Stack>
            </SectionStyle>

            <ContentStyle>
                <Stack sx={{ width: 1, maxWidth: 480, margin: 'auto' }}>
                    {children}

                    {/* Powered By Footer */}
                    <Typography variant="caption" sx={{ mt: 5, textAlign: 'center', color: 'primary.main', width: '100%' }}>
                        Powered by <span style={{ fontWeight: 'bold' }}>{appName}</span> Digital Media
                    </Typography>
                </Stack>
            </ContentStyle>
        </RootStyle>
    );
}
